import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import Modal from '../../modal/Modal';
import animation from '../../../images/load-rewards-screen-animation.gif';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

var FetchRewardOverlay = function FetchRewardOverlay(props) {
  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      show = props.show,
      hide = props.hide;
  var Header = model.Header,
      SubHeader = model.SubHeader,
      StepsList = model.StepsList;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      gif = _useState2[0],
      setGif = _useState2[1];

  useEffect(function () {
    if (show) {
      setGif("".concat(animation, "?").concat(Date.now()));
    } else {
      setGif(null);
    }
  }, [show]);
  return /*#__PURE__*/React.createElement(Modal, {
    className: 'fetch-reward-overlay',
    show: show,
    hide: hide,
    hideCloseButton: true,
    backdrop: false
  }, /*#__PURE__*/React.createElement("div", {
    className: 'fetch-reward-overlay__container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'fetch-reward-overlay__animation-container'
  }, gif && /*#__PURE__*/React.createElement("img", {
    className: 'fetch-reward-overlay__animation',
    src: gif,
    alt: 'Loading Rewards',
    autoPlay: true
  })), /*#__PURE__*/React.createElement("div", {
    className: 'fetch-reward-overlay__copy'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'fetch-reward-overlay__header'
  }, Header === null || Header === void 0 ? void 0 : Header.value), /*#__PURE__*/React.createElement("span", {
    className: 'fetch-reward-overlay__sub-header'
  }, SubHeader === null || SubHeader === void 0 ? void 0 : SubHeader.value), /*#__PURE__*/React.createElement(RichText, {
    field: StepsList,
    tag: 'div',
    className: 'fetch-reward-overlay__list'
  }))));
};

export default FetchRewardOverlay;